import Context from './context'
import {useContext} from 'react'

const useApp = () => useContext(Context)

export default useApp